if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.handleContentScroll = this.handleContentScroll.bind(this);
        this.handleThumbClick = this.handleThumbClick.bind(this);
        this.addEventListener('click', this.handleThumbClick);
      }

      hide() {
        this.content?.removeEventListener('scroll', this.handleContentScroll);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.content?.addEventListener('scroll', this.handleContentScroll, { passive: true });
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.mediaItems.forEach((element) => {
          element.classList.add('active');
        });

        const requestedMediaId = this.openedBy.getAttribute('data-media-id');
        const activeMedia =
          this.content?.querySelector(`[data-media-id="${requestedMediaId}"]`) || this.mediaItems[0];
        if (!activeMedia) return;

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();
        this.setActiveThumb(activeMedia.dataset.mediaId);

        const container = this.content;
        if (activeMedia.width) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        requestAnimationFrame(() => this.handleContentScroll());
      }

      handleThumbClick(event) {
        const button = event.target.closest('.product-media-modal__thumb');
        if (!button || !this.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const media = this.content?.querySelector(`[data-media-id="${button.dataset.mediaId}"]`);
        if (!media) return;

        media.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.setActiveThumb(button.dataset.mediaId);
      }

      handleContentScroll() {
        const media = this.mediaItems;
        if (!media.length) return;

        const viewportCenter = this.content.scrollTop + this.content.clientHeight / 2;
        const activeMedia = media.reduce((closest, item) => {
          const itemCenter = item.offsetTop + item.offsetHeight / 2;
          const itemDistance = Math.abs(itemCenter - viewportCenter);
          const closestCenter = closest.offsetTop + closest.offsetHeight / 2;
          const closestDistance = Math.abs(closestCenter - viewportCenter);

          return itemDistance < closestDistance ? item : closest;
        }, media[0]);

        this.setActiveThumb(activeMedia.dataset.mediaId);
      }

      setActiveThumb(mediaId) {
        const thumbs = this.querySelector('.product-media-modal__thumbs');
        if (!thumbs || !mediaId) return;

        thumbs.querySelectorAll('.product-media-modal__thumb').forEach((button) => {
          const isActive = button.dataset.mediaId === mediaId;
          button.classList.toggle('is-active', isActive);
          if (isActive) {
            button.setAttribute('aria-current', 'true');
            button.scrollIntoView({ block: 'nearest' });
          } else {
            button.removeAttribute('aria-current');
          }
        });

        this.updateScrollIndicator();
      }

      updateScrollIndicator() {
        const indicator = this.querySelector('[data-scroll-indicator]');
        const activeThumb = this.querySelector('.product-media-modal__thumb.is-active');
        if (!indicator || !activeThumb) return;

        indicator.style.setProperty('--scroll-indicator-height', `${activeThumb.offsetHeight}px`);
        indicator.style.setProperty('--scroll-indicator-top', `${activeThumb.offsetTop}px`);
      }

      get content() {
        return this.querySelector('.product-media-modal__content');
      }

      get mediaItems() {
        if (!this.content) return [];

        return Array.from(this.content.children).filter((item) => item.dataset.mediaId);
      }
    }
  );
}
